import Reveal from "./Reveal";

export default function Manifesto() {
  return (
    <section className="relative overflow-hidden bg-secondary-50 py-16 md:py-36">
      {/* subtle botanical decoration */}
      <div className="pointer-events-none absolute -right-16 -top-16 text-primary-500/10">
        <i className="ri-leaf-line text-[16rem]" aria-hidden="true"></i>
      </div>
      <div className="pointer-events-none absolute -bottom-20 -left-10 text-primary-500/10">
        <i className="ri-plant-line text-[14rem]" aria-hidden="true"></i>
      </div>

      <div className="relative mx-auto max-w-4xl px-4 text-center md:px-6">
        <Reveal>
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-primary-600/25 text-primary-600">
            <i className="ri-leaf-line text-xl" aria-hidden="true"></i>
          </span>
        </Reveal>

        <Reveal delay={80}>
          <h2 className="mx-auto mt-10 max-w-3xl font-heading text-4xl font-medium leading-[1.15] tracking-tight text-foreground-950 md:text-6xl">
            “Cicatrizar vai muito além de fechar uma ferida.”
          </h2>
        </Reveal>

        <Reveal delay={160}>
          <p className="mx-auto mt-8 max-w-xl text-lg leading-relaxed text-foreground-600 md:text-xl">
            É recuperar conforto, segurança, autonomia e qualidade de vida.
          </p>
        </Reveal>

        <Reveal delay={220}>
          <div className="mx-auto mt-12 h-px w-24 bg-primary-600/25" />
        </Reveal>
      </div>
    </section>
  );
}